var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebpage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    fill: "#99ea24",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Webinar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Assignment"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Article"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Audi"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Video_Tutorial"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Discussion_1_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Resume"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Trophy"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Encyclopedia"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Smartphone"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Online_Lesson"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Webpage"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.44,
    cy: 6.614,
    r: 0.804
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.272,
    cy: 6.614,
    r: 0.804
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.104,
    cy: 6.614,
    r: 0.804
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.071 20.191 2.623 8.622c.254.835 1.43.853 1.709.025l1.228-3.644c.09-.266.298-.474.564-.564l3.644-1.228c.827-.279.81-1.455-.025-1.709l-8.622-2.623c-.687-.208-1.329.434-1.121 1.121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.637 20.627c-.224-.734-.09-1.509.366-2.124.452-.609 1.17-.973 1.923-.973.237 0 .473.035.703.105l7.752 2.357v-13.721c0-2.05-1.67-3.72-3.72-3.72h-20.391c-2.05 0-3.72 1.67-3.72 3.72v16.65c0 2.06 1.67 3.73 3.73 3.73h15.188zm-15.287-11.736v-2.619c0-1.059.861-1.92 1.92-1.92h20.39c1.059 0 1.92.861 1.92 1.92v2.619z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Registration"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Certificate_1_"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Review"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Ebook"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Online_Class_1_"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Schedule"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Idea"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Login"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Science"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Time"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Business"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Projector"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpage);
export default __webpack_public_path__ + "static/media/webpage.65871ed8564657269895f4a9d8f638c2.svg";
export { ForwardRef as ReactComponent };